import React from 'react';
import Colors from '../../../../../config/Colors';
import { Button } from '../../../../../components-reactjs/Button';

import {
    FreteModalContainer,
    ModalHeader,
    ModalHeaderTitle,
    ModalContent,
    Descricao,
    ModalFooter
} from '../../styles';

import { ItemInfoText } from './styles';

export const FreteExcludeItem = ({
    title,
    itemFrete,
    labelContent,
    excludeHandler,
    index,
    handleCloseModal,
    ...props
}) => {
    return (
        <FreteModalContainer className="modal-exclude-frete-content">
            <ModalHeader>
                <ModalHeaderTitle>{title}</ModalHeaderTitle>
            </ModalHeader>
            <ModalContent className="content">
                <Descricao>
                    <ItemInfoText>{labelContent}</ItemInfoText>
                </Descricao>
            </ModalContent>
            <ModalFooter className="buttons">
                <Button
                    onClick={() => {
                        props.setIsOpen(false);
                    }}
                    style={{
                        backgroundColor: `${Colors.grey_light}`,
                        color: `${Colors.dark}`,
                        border: `1px solid ${Colors.regular}`,
                        marginRight: 15,
                        minHeight: 45,
                        minWidth: 135
                    }}
                    title="Cancelar"
                />
                <Button
                    onClick={() => {
                        excludeHandler(index);
                        handleCloseModal(false);
                    }}
                    style={{
                        minHeight: 45,
                        minWidth: 135,
                        fontWeight: 'bold'
                    }}
                    title="Ok"
                />
            </ModalFooter>
        </FreteModalContainer>
    );
};
